// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@gcg/XDL/Icons/Close";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Clickable from "@insite/mobius/Clickable/Clickable";
import Icon from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface ListingUploadedFilesProps {
    files: any;
    clearFromHolder: Function;
}

export interface ListingUploadedFilesStyles {
    selectedFileStyle?: InjectableCss;
    close?: InjectableCss;
}

export const uploadFilesModalStyles: ListingUploadedFilesStyles = {
    selectedFileStyle: {
        css: css`
            display: flex;
            margin-top: 5px;
            padding: 5px;
        `,
    },
    close: {
        css: css`
            margin-left: 5px;
        `,
    },
};

const styles = uploadFilesModalStyles;

const ListingUploadedFiles: React.FC<ListingUploadedFilesProps> = ({ files, clearFromHolder }) => {
    if (!files.length) {
        return null;
    }

    return (
        <StyledWrapper>
            {files.map((file: any, index: any) => {
                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <StyledWrapper key={`${file.name}${index}`} {...styles.selectedFileStyle}>
                        {file.name}{" "}
                        <Clickable
                            {...styles.close}
                            onClick={() => {
                                clearFromHolder(index);
                            }}
                        >
                            <Icon src={Close} color="danger" size={10} />
                        </Clickable>
                    </StyledWrapper>
                );
            })}
        </StyledWrapper>
    );
};

export default ListingUploadedFiles;
